import {
  Datagrid,
  List,
  NumberField,
  Pagination,
  SimpleList,
  TextField,
  useRecordContext,
} from "react-admin";
import DisplayDateField from "@/components/DisplayDateField";
import Box from "@mui/material/Box";
import { useMediaQuery } from "@mui/material";
import { formatListDate } from "@/utils/date-format";

export const ProjectShowReceiptsTab = () => {
  const record = useRecordContext<{ id?: string }>();
  const projectId = record?.id;
  const isSmall = useMediaQuery((theme) => theme.breakpoints.down("sm"), { noSsr: true });

  if (!projectId) return null;

  return (
    <List
      resource="projectTakhmeenReceipts"
      filter={{ projectId }}
      perPage={25}
      sort={{ field: "receiptDate", order: "DESC" }}
      pagination={<Pagination rowsPerPageOptions={[10, 25, 50]} />}
      disableSyncWithLocation
    >
      {isSmall ? (
        <SimpleList
          primaryText={(r) => String(r.receiptNo ?? "—")}
          secondaryText={(r) =>
            `₹${Number(r.amount ?? 0).toLocaleString("en-IN")} · ${String(r.paymentMode ?? "")}`
          }
          tertiaryText={(r) => (r.receiptDate ? formatListDate(String(r.receiptDate)) : "—")}
          linkType="show"
          rowSx={() => ({ borderBottom: 1, borderBottomColor: "divider" })}
        />
      ) : (
        <Box sx={{ overflowX: "auto", width: "100%" }}>
          <Datagrid bulkActionButtons={false} rowClick="show" sx={{ minWidth: 640 }}>
            <TextField source="receiptNo" emptyText="—" />
            <NumberField source="amount" options={{ style: "currency", currency: "INR" }} />
            <TextField source="paymentMode" />
            <TextField source="paymentRef" emptyText="—" />
            <DisplayDateField source="receiptDate" />
          </Datagrid>
        </Box>
      )}
    </List>
  );
};
